import { Location } from '@angular/common';
import { Injectable, signal } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class NavigationService {
  constructor(
    private location: Location,
    private router: Router
  ) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.previousUrl.set(this.currentUrl());
        this.currentUrl.set(event.url);
      }
    });
  }

  public direction: 'back' | 'forward' | 'none' = 'none';
  private previousUrl = signal('');
  private currentUrl = signal('');

  back(path = '') {
    this.direction = 'back';

    if (path === '') {
      this.location.back();
    } else {
      this.router.navigate([path]);
    }
  }

  forward(path = '') {
    this.direction = 'forward';

    if (path === '') {
      this.location.forward();
    } else {
      this.router.navigate([path]);
    }
  }
  getCurrentUrl() {
    return this.currentUrl();
  }
  getPreviousUrl() {
    return this.previousUrl();
  }
}
